module.exports = __webpack_public_path__ + "assets/img/Dialog.bce37ff6.svg";